import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ProducerEntityType } from '../types/ProducerEntityType';
import {
  CreateProducerFieldKey,
  CreateProducerFieldValue,
  CreateProducerState,
} from './types/createProducerSliceTypes';
import { CreateProducerEntityRequest } from './types/requests/CreateProducerEntityRequest';
import { createProducerInitialState } from './constants/createProducerSliceConstants';

const createProducerSlice = createSlice({
  name: 'createProducer',
  initialState: createProducerInitialState,
  reducers: {
    changeCreateProducerType: (state: CreateProducerState, action: PayloadAction<ProducerEntityType>) => {
      state.createProducerType = action.payload;
    },
    updateCreateProducerStepValues: <K extends CreateProducerFieldKey>(
      state: CreateProducerState,
      action: PayloadAction<{ step: K; value: CreateProducerFieldValue<K> }>,
    ) => {
      const { step, value } = action.payload;
      state.createProducerSteps[step] = value;
    },
    resetCreateProducerState: () => createProducerInitialState,
    createProducer: (_, _action: PayloadAction<CreateProducerEntityRequest>) => {},
    createProducerSuccess: () => {},
    setCreateProducerLoadingStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isCreateProducerLoading = payload;
    },
  },
  selectors: {
    selectCreateProducerSteps: (state) => state.createProducerSteps,
    selectCreateProducerType: (state) => state.createProducerType,
    selectCreateProducerIsLoading: (state) => state.statuses.isCreateProducerLoading,
  },
});

export const {
  updateCreateProducerStepValues,
  resetCreateProducerState,
  changeCreateProducerType,
  createProducer,
  createProducerSuccess,
  setCreateProducerLoadingStatus,
} = createProducerSlice.actions;

export const { selectCreateProducerSteps, selectCreateProducerType, selectCreateProducerIsLoading } =
  createProducerSlice.selectors;

export const createProducerReducer = createProducerSlice.reducer;
export const createProducerReducerPath = createProducerSlice.reducerPath;
